export const framerCommon = {
  initial: 'hidden',
  whileInView: 'visible',
  viewport: { once: true },
  transition: { duration: 1, delay: 0 },
};

export const imageVariants = isMainDirection => ({
  hidden: {
    right: isMainDirection ? '-25%' : '25%',
    opacity: 0,
  },
  visible: {
    right: '0',
    opacity: 1,
  },
});

export const titleVariants = {
  hidden: {
    top: '-25%',
    opacity: 0,
  },
  visible: {
    top: '0',
    opacity: 1,
  },
};

export const descriptionVariants = {
  hidden: {
    bottom: '-25%',
    opacity: 0,
  },
  visible: {
    bottom: '0',
    opacity: 1,
  },
};

export const assistanceBadgeTitle = {
  hidden: {
    top: '0',
    scale: 2.5,
    marginLeft: '29%',
  },
  visible: {
    top: '0',
    scale: 1,
    marginLeft: 0,
  },
};

export const assistanceBadgeDescription = {
  hidden: {
    height: '1px',
    bottom: '-20%',
  },
  visible: {
    height: '100%',
    bottom: 0,
  },
};
